(function ($) {
	$.fn.frOpenModals = function () {
		const removeHash = () => {
			history.pushState("", document.title, window.location.pathname + window.location.search);
		}

        const resourceClickHandler = (resourceModalSlug, resourceId) => {
            const $resourceModal = $('#fr-modal-' + resourceModalSlug);

            if($resourceModal.length){
                $resourceModal.trigger('fr-load-resource-details', [resourceId]);
            }
        }

		const openLockedResourceModal = (modalSlug, postId) => {
			const $modal = $('#fr-modal-' + modalSlug);

			if($modal.length){
				$modal.trigger('fr:open-locked-resource-modal', [postId]);
			}
		}

		return this.each((i, el) => {
			const hash = window.location.hash.replace('#', '');
			const submissionForms = window.fr_submission_forms_vars;
			const publishCardsModalSlug = window.fr_publish_cards_modal_url_slug || false;
            const resourceModalSlug = window.fr_resource_modal_url_slug || false;
			const lockedResourceModalSlug = window.salesforce_integration_modal_url_slug || false;
			const jsVars = submissionForms.concat(
				{'url_slug': publishCardsModalSlug}, 
				{'url_slug': resourceModalSlug}, 
				{'url_slug': lockedResourceModalSlug}
			).filter(el => el.url_slug.length);

			if (hash) {
                if(hash.startsWith(resourceModalSlug)){
                    var resourceId = hash.replace(resourceModalSlug + '-', '');
                    resourceClickHandler(resourceModalSlug, resourceId);
                }else{
                    $('#fr-modal-' + hash).modal('show');
                }
			}

			if(jsVars && jsVars.length){
				const selectors = [];
				jsVars.forEach(el => {
                    const slug = el.url_slug;

                    if([resourceModalSlug, lockedResourceModalSlug].includes(slug)){
                        selectors.push(`a[href^="#${slug}"]`);
                    }else{
                        selectors.push('a[href="#'+slug+'"]');
                    }

					//REMOVE HASH AFTER MODAL IS HIDDEN
					$('#fr-modal-'+slug).on('hidden.bs.modal', (ev) => {
						if(window.location.hash.replace('#', '') === slug || (slug === resourceModalSlug)){
							removeHash();
						}
					});

					//ADD HASH AFTER MODAL IS SHOWN
					$('#fr-modal-'+slug).on('shown.bs.modal', (ev) => {
                        if([resourceModalSlug, lockedResourceModalSlug].includes(slug)) return;
						window.location.hash = slug;
					});

                    //HIDE OTHER MODALS
					$('#fr-modal-'+slug).on('show.bs.modal', (ev) => {
						if(slug === lockedResourceModalSlug) return;
						$('.modal').not('#fr-modal-'+slug).modal('hide');
					});
				});

				//set Up button click event
				$(document).on("click", selectors.join(', '), (ev) => {
                    const hrefAttr = $(ev.currentTarget).attr('href').replace('#', '');

                    if(hrefAttr.startsWith(resourceModalSlug)){
                        resourceClickHandler(resourceModalSlug, hrefAttr.replace(resourceModalSlug + '-', ''));
                    }else if(hrefAttr.startsWith(lockedResourceModalSlug)){
						ev.preventDefault();
						openLockedResourceModal(lockedResourceModalSlug, hrefAttr.replace(lockedResourceModalSlug + '-', ''));
                    }else{
						$('#fr-modal-' + hrefAttr).modal('show');
					}
				});


				//On PAGE LOAD IF has varialbes to open RESUBMIT FORM
				if(window.fr_resubmit_data_vars && window.fr_resubmit_data_vars.form_slug){
					//disable closing the window
					$('#fr-modal-' + window.fr_resubmit_data_vars.form_slug).find('button.btn-close').remove();
					$('#fr-modal-' + window.fr_resubmit_data_vars.form_slug).modal('show');
				}
			}
		});
	}

	$(() => {
		$('body').frOpenModals();
	});
})($);
